<div class="w-full" style="width: 100%; position: fixed">
  <form [formGroup]="form">
    <div *ngFor="let lists of list" class="w-4/6 h-full shadow-md bg-white rounded-lg">
      <div class="text-gray-900 bg-gray-200 p-4 rounded-lg shadow-md">
        <div class="mb-10 text-2xl">
          <span *ngIf="translate.currentLang == 'kz'"> {{ lists.id }} - {{ lists.nameKaz }} </span>
          <span *ngIf="translate.currentLang == 'ru'"> {{ lists.id }} - {{ lists.nameRus }} </span>
        </div>
        <div class="my-2 ">
            <div class="my-2">
              <label class="mr-3"> {{ 'Область' | translate }} </label>
              <select [ngClass]="{'is-invalid': form.get('oblId')?.invalid && (form.get('oblId')?.touched)}"
                      formControlName="oblId" class="rounded-lg mr-20 flex-grow w-full px-3">
                <option [value]="0" disabled selected> {{ 'Область' | translate }} </option>
                <option *ngFor="let item of oblList" [value]="item.id">
                  <span *ngIf="translate.currentLang == 'kz'"> {{ item.nameKaz }} </span>
                  <span *ngIf="translate.currentLang == 'ru'"> {{ item.nameRus }} </span>
                </option>
              </select>
              <div *ngIf="form.get('oblId')?.invalid && (form.get('oblId')?.touched)" class="text-red-500 text-sm">
                {{ 'Поле обязательно для заполнения' | translate }}
              </div>
            </div>
          <div>
            <label class="mr-3"> {{ 'Наименование на казахском' | translate }} </label>
            <input formControlName="nameKaz" type="text" class="rounded-lg border-2 mr-20 w-full px-2"
                   [ngClass]="{'is-invalid': form.get('nameKaz')?.invalid && (form.get('nameKaz')?.touched)}">
            <div *ngIf="form.get('nameKaz')?.invalid && (form.get('nameKaz')?.touched)" class="text-red-500 text-sm">
              {{ 'Поле обязательно для заполнения' | translate }}
            </div>
          </div>
          <div class="mк-3">
            <label class="mr-3"> {{ 'Наименование на русском' | translate }} </label>
            <input formControlName="nameRus" type="text" class="rounded-lg border-2 mr-20 w-full px-2"
                   [ngClass]="{'is-invalid': form.get('nameRus')?.invalid && (form.get('nameRus')?.touched)}">
            <div *ngIf="form.get('nameRus')?.invalid && (form.get('nameRus')?.touched)" class="text-red-500 text-sm">
              {{ 'Поле обязательно для заполнения' | translate }}
            </div>
          </div>
        </div>
        <div class="flex mt-5">
          <label>
            Отображать в списке при подаче заявок
          </label>
            <input class="ml-4 mt-1" style="width: 15px; height: 15px" formControlName="isEnabled" type="checkbox" >
        </div>
      </div>
      <div class="flex">
        <button (click)="updateInstitute()" class="my-5 w-1/2 mx-3 font-serif py-1 px-24 bg-blue-300 rounded-lg text-grey-darker">
          {{ 'Сохранить' | translate}}
        </button>
        <button (click)="goBack()" class="mx-3 font-serif my-5 w-1/2 rounded-lg py-1 text-center px-24 bg-red-400 text-grey-darker">
          {{ 'Cancellation' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
